export default "__VITE_ASSET__zFnemo0L__"